import initialState from '../../app.state.jsx';
import { Map, List, fromJS } from 'immutable';
//import { rangeIter } from '../../../common/utils.jsx';

export const AUTOCOMPLETE_STATUS_IDLE = 'idle';
export const AUTOCOMPLETE_STATUS_PENDING = 'pending';

export const AJAX_AUTOCOMPLETE_INIT = 'app/autocomplete/AJAX_AUTOCOMPLETE_INIT';
export const AJAX_AUTOCOMPLETE_INIT_DATA = 'app/autocomplete/AJAX_AUTOCOMPLETE_INIT_DATA';

export function initAjaxAutocomplete(name) {
    return {
        type: AJAX_AUTOCOMPLETE_INIT,
        name
    };
}

export const AJAX_AUTOCOMPLETE_REMOVE = 'app/autocomplete/AJAX_AUTOCOMPLETE_REMOVE';

export function removeAjaxAutocomplete(name) {
    return {
        type: AJAX_AUTOCOMPLETE_REMOVE,
        name
    };
}

export const AJAX_AUTOCOMPLETE_FETCH = 'app/autocomplete/AJAX_AUTOCOMPLETE_FETCH';
export const AJAX_AUTOCOMPLETE_RESPONSE = 'app/autocomplete/AJAX_AUTOCOMPLETE_RESPONSE';
export const AJAX_AUTOCOMPLETE_FAIL = 'app/autocomplete/AJAX_AUTOCOMPLETE_FAIL';

export function fetchAutocompleteData(name, service, payload) {
    return {
        type: AJAX_AUTOCOMPLETE_FETCH,
        name, service, payload
    };
}

export function initAutocompleteData(name, service, payload) {
    return {
        type: AJAX_AUTOCOMPLETE_INIT_DATA,
        name, service, payload
    };
}

export function response(name, serviceName, payload, data) {
    return {
        type: AJAX_AUTOCOMPLETE_RESPONSE,
        name, payload, response: data, service: serviceName
    };
}

export function fail(name, serviceName, payload, error) {
    return {
        type: AJAX_AUTOCOMPLETE_FAIL,
        name, payload, error, service: serviceName
    };
}

export const AJAX_AUTOCOMPLETE_SET_TEXT = 'app/autocomplete/AJAX_AUTOCOMPLETE_SET_TEXT';

export function setAutocompleteText(name, value, savePreviousValue = false) {
    return {
        type: AJAX_AUTOCOMPLETE_SET_TEXT,
        name, value, save: savePreviousValue
    };
}
const initAutocompleteState = { status: AUTOCOMPLETE_STATUS_IDLE, text: '' };
export const CONCEPT_SERVICE = 'concept';
export const QUESTIONNAIRE_SERVICE = 'questionnaire';
export const converters = {
    [CONCEPT_SERVICE] : function _convertConcept({ id, title, code }) { return { value: id, name: title, code }; },
    [QUESTIONNAIRE_SERVICE] : function _convertQuestionnaireCondition({ label, code }) {
        return { value: code, name: label, code };
    }
};
export function _extendAsOption(item) { item.value = item.id; item.name = item.title; return item; }
export function updateMap(map, concepts, prop) {
    return map.withMutations((localState) => {
        concepts.forEach((concept) => {
            if (localState.has(concept[prop])) { return; }
            let key = concept[prop];
            if ('string' === typeof  key) { key = key.toLowerCase(); }
            localState.set(key, concept);
        });
    });
}

function _conceptNameComparator(left, right) {
    if (left.name < right.name) { return -1; }
    if (left.name > right.name) { return 1; }
    return 0;
}

export default function autocompleteReducer(state = initialState.getIn([ 'components', 'autocomplete' ]), action = null) {
    const { name, service } = action;
    switch (action.type) {
        case AJAX_AUTOCOMPLETE_INIT:
            return state.set(name, fromJS(initAutocompleteState));
        case AJAX_AUTOCOMPLETE_REMOVE:
            return state.remove(name);
        case AJAX_AUTOCOMPLETE_FETCH:
            return state.setIn([ name, 'status' ], AUTOCOMPLETE_STATUS_PENDING);
        case AJAX_AUTOCOMPLETE_RESPONSE:
            const conceptsList = action.response.map(converters[service]);
            const storageName = action.payload.storageName;
            const stringValue = action.payload.string;
            const conceptStorage = state
                .getIn([ '__storage__', storageName ], new Map())
                .withMutations((localState) => {
                    const idMap = localState.get('idMap', new Map());
                    const nameMap = localState.get('nameMap', new Map());
                    const updatedIdMap = updateMap(idMap, conceptsList, 'value');
                    const updatedNameMap = updateMap(nameMap, conceptsList, 'name');
                    const fullList = [];
                    const updatedIdArray = updatedIdMap.toJS();
                    const updatedIdKeys = Object.keys(updatedIdArray);
                    for (const key of updatedIdKeys) { fullList.push(updatedIdArray[key]); }
                    return localState
                        .setIn([ 'cache', stringValue || 'all' ], new List(conceptsList))
                        .set('idMap', updatedIdMap)
                        .set('nameMap', updatedNameMap)
                        .set('fullList', fullList.sort(_conceptNameComparator));
                });
            let textValue = '';
            if ('number' === typeof action.payload.value) {
                textValue = conceptStorage.getIn([ 'idMap', action.payload.value ]).name || stringValue;
            }
            const updatedState = fromJS({
                text: textValue,
                prevText: action.string,
                status: AUTOCOMPLETE_STATUS_IDLE
            });
            return state
                .set(name, updatedState)
                .setIn([ '__storage__', storageName ], conceptStorage);
        case AJAX_AUTOCOMPLETE_FAIL:
            return state.setIn([ name, 'status' ], AUTOCOMPLETE_STATUS_IDLE);
        case AJAX_AUTOCOMPLETE_SET_TEXT:
            const componentState = state.get(name);
            const updatedComponentState = componentState.withMutations((localState) => {
                if (action.save) {
                    const prevText = localState.get('text');
                    localState.set('prevText', prevText);
                }
                return localState.set('text', action.value);
            });
            return state.set(name, updatedComponentState);
        default:
            return state;
    }
}
